export default {
  budgetAllocationAndMediaMix: 'Alocação de Orçamento e Mix de Mídia',
  salesDecomposition: 'Decomposição de {kpi}',
  mediaEffect: 'Efeito de Mídia',
  competitionEffect: 'Efeito de Concorrência',
  economyAndOthersEffect: 'Efeito de Economia e Outros',
  pricingEffect: 'Efeito de Preços',
  distributionEffect: 'Efeito de Distribuição',
  seasonalityAndOutliersEffect: 'Efeito de Sazonalidade e Outliers',
  spend: 'Investimento'
}
